import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { pollPayPayPaymentStatus } from "works/higurashi/utils/api";
import { Typography, Box } from "@mui/material";
import AppLayout from "works/higurashi/components/AppLayout";
import StyledButton from "default/components/StyledButton";
import { COLORS } from "constants/colors";
import { useUrlParams } from "works/higurashi/hooks/useUrlParams";

// Constants
const POLLING_INTERVAL = 3000; // 3 seconds
const PAYMENT_STATUS = {
  COMPLETED: "COMPLETED",
};

// Custom hook for payment polling
const usePaymentPolling = (merchantPaymentId, work, accountKey, navigate) => {
  const isActiveRef = useRef(true);

  const startPolling = async () => {
    while (isActiveRef.current) {
      try {
        const { status } = await pollPayPayPaymentStatus(merchantPaymentId);
        if (status === PAYMENT_STATUS.COMPLETED) {
          const targetPath = `/${work}/how-to-use?account=${accountKey}`;
          navigate(targetPath);
          return;
        }
      } catch (error) {
        console.error("Polling error:", error);
      }

      await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL));
    }
  };

  useEffect(() => {
    if (merchantPaymentId) {
      startPolling();
    }

    return () => {
      isActiveRef.current = false;
    };
  }, [merchantPaymentId, work, navigate]);

  return {
    stopPolling: () => {
      isActiveRef.current = false;
    },
  };
};

// Component for polling content
const PollingContent = () => (
  <Box
    sx={{
      width: "88%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: COLORS.BACKGROUND_WHITE,
      borderRadius: "5px",
      padding: 4,
      gap: 4,
    }}
  >
    <Typography
      variant="h6"
      sx={(theme) => ({
        whiteSpace: "pre-line",
        fontWeight: "bold",
        textAlign: "center",
        color: COLORS.TEXT_BLACK,
        mt: 1,
      })}
    >
      {"購入手続きは\nまだ完了していません"}
    </Typography>

    <Box>
      <Typography
        sx={(theme) => ({
          fontSize: "15px",
          whiteSpace: "pre-line",
          fontWeight: "bold",
          textAlign: "center",
          lineHeight: "1.8",
          color: "red",
          border: "1px solid red",
          borderRadius: "4px",
          padding: "8px",
          mt: 1,
        })}
      >
        画面を閉じずにお待ちください
      </Typography>
    </Box>

    <StyledButton
      variant="contained"
      sx={{
        width: "100%",
        fontSize: "17px",
        color: COLORS.TEXT_BLACK,
        border: `2px solid ${COLORS.TEXT_BLACK}`,
      }}
      onClick={() => {}}
    >
      購入を完了する
    </StyledButton>
  </Box>
);

function PayPayPolling() {
  const navigate = useNavigate();
  const location = useLocation();
  const { work, accountKey } = useUrlParams();

  const queryParams = new URLSearchParams(location.search);
  const merchantPaymentId = queryParams.get("merchant_payment_id");

  usePaymentPolling(merchantPaymentId, work, accountKey, navigate);

  return (
    <AppLayout page="PayPayPolling">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <PollingContent />
      </Box>
    </AppLayout>
  );
}

export default PayPayPolling;
